module.exports = __webpack_public_path__ + "static/media/JioIcon.5dcf53b4.svg";